import { render, staticRenderFns } from "./ScholarshipsListing.vue?vue&type=template&id=4339b2d5&"
import script from "./ScholarshipsListing.vue?vue&type=script&lang=js&"
export * from "./ScholarshipsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports